import apiClient from '@/repositories/apiClient';

const defaultFetch = ({
  url,
  requestOptions = defaultRequestOptions,
  responseHandler = defaults.handleResponse,
  errorHandler = defaults.handleError,
  timeout = 80000,
}) => {
  return apiClient({url: url, method: requestOptions.method, data: requestOptions.body, timeout: timeout})
    .then(responseHandler)
    .catch(errorHandler);
};

const defaultRequestOptions = (method = 'GET') => {
  return {
    method,
  };
};

const services = (prefix, prefixs) => {
  const get = (id) => {
    const requestOptions = {
      ...defaultRequestOptions('GET'),
    };
    return defaultFetch({ url: `/${prefix}/${id}`, requestOptions });
  };

  const update = (form) => {
    const requestOptions = {
      ...defaultRequestOptions('POST'),
      body: JSON.stringify(form),
    };

    let id = -1;

    if (form.model) {
      id = form.model.ID;
    } else {
      if (form.item) {
        if (form.item.model) {
          id = form.item.model.ID;
        } else {
          id = form.item.details.ID;
        }
      } else {
        id = form.details.ID;
      }
    }

    return defaultFetch({ url: `/${prefix}/${id}`, requestOptions });
  };

  const create = (form) => {
    const requestOptions = {
      ...defaultRequestOptions('POST'),
      body: JSON.stringify(form),
    };

    return defaultFetch({ url: `/${prefix}`, requestOptions });
  };

  const remove = (id) => {
    const requestOptions = {
      ...defaultRequestOptions('DELETE'),
    };
    return defaultFetch({ url: `/${prefix}/${id}`, requestOptions });
  };

  const all = (skip = 0, limit = 5, filter = {}) => {
    const form = {
      skip,
      limit,
      filter,
    };

    const requestOptions = {
      ...defaultRequestOptions('POST'),
      body: JSON.stringify(form),
    };
    return defaultFetch({ url: `/${prefixs}`, requestOptions });
  };

  const pagination = (
    pageIndex = 0,
    pageSize = 5,
    sortBy = [],
    filters = [],
    search = null
  ) => {
    const form = {
      pageIndex,
      pageSize,
      sortBy,
      filters,
      search,
    };

    const requestOptions = {
      ...defaultRequestOptions('POST'),
      body: JSON.stringify(form),
    };
    return defaultFetch({ url: `/${prefixs}`, requestOptions });
  };

  return {
    get,
    all,
    pagination,
    update,
    remove,
    create,
  };
};

const handleError = (error) => {
  if (error.response) {
    return { error: error.response.data, status: error.response.status };
  } else {
    return { error: error.message, status: 500 };
  }
}

const handleResponse = (response) => {
  return new Promise((resolve, reject)  => {
    if (response.status === 404 || response.status === 500) {
      return reject({
        status: `Fehler ${response.status}`,
        error: response.data
          ? response.data
          : 'Vorgang musste abgebrochen werden!\nProbiere es nochmal oder kontaktiere den Support.',
      });
    }
    console.info("RESPONSE: ", response);
    try {
      const data = response.data;
      if (data.status === false) {
        const error = data.message;
        return reject({ error: error, status: response.status });
      }
    } catch (err) {
      return reject({ error: err, status: response.status });
    }
    // if no error then go to normal processing
    return resolve(response.data);
  });
};

const defaults = {
  defaultRequestOptions,
  services,
  handleResponse,
  handleError,
  defaultFetch,
};

export default defaults;
